import { render, staticRenderFns } from "./Computer.vue?vue&type=template&id=6144845c"
import script from "../services/Computer.js?vue&type=script&lang=js&external"
export * from "../services/Computer.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports